export const AVAILABILITY_WS_EVENTS = {
  CONNECTED: 'ws:connected',
  DISCONNECTED: 'ws:disconnected',
  MESSAGE: 'ws:message',
  RECONNECTING: 'ws:reconnecting',
  RESTORED: 'ws:restored',
  INITIAL_STATE: 'ws:initial-state',
  ACTIVITY_UPDATE: 'ws:activity-update',
  INTERRUPTION_DELIVERED: 'ws:interruption-delivered',
  INTERRUPTION_CANCELLED: 'ws:interruption-cancelled',
  INTERRUPTION_RESPONSE_STATUS_CHANGED: 'ws:interruption-response-status-changed',
  INITIAL_INTERRUPTION: 'ws:initial-interruptions',
  FOCUS_SCHEDULES_UPDATED: 'ws:focus-schedules-updated',
  NOTIFICATION_DELIVERED: 'ws:notification-delivered',
} as const;

export const AVAILABILITY_WS_INITIAL_RECONNECT_DELAY_MS = 2_000;
export const AVAILABILITY_WS_MAX_RECONNECT_DELAY_MS = 30_000;
// A connection must stay open this long before the reconnect backoff starts over.
export const AVAILABILITY_WS_STABLE_CONNECTION_MS = 30_000;
